import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  asideContainer: {
    width: "364px",
    flexShrink: 0,
    borderRight: `1px solid ${semanticColors.border.secondary}`,
    overflowY: "auto",
    overflowX: "hidden",
    transition: "width 0.2s ease",
    height: "100%",
  },
  asideContainerCollapsed: {
    width: "40px",
    overflow: "hidden",
  },
  root: {
    width: "332px",
    flexShrink: 0,
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: semanticColors.background.primary,
    borderRight: `1px solid ${semanticColors.border.secondary}`,
    transition: "width 0.2s ease",
    height: "100%",
  },
  rootCollapsed: {
    width: "40px",
    padding: 0,
    overflow: "hidden",
  },
  sidebarHeaderRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  toggleButton: {
    padding: "4px",
    color: semanticColors.foreground.secondary,
    flexShrink: 0,
  },
  collapsedButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "38px",
    height: "100%",
    minHeight: "100px",
    padding: "8px 0",
    gap: "8px",
    backgroundColor: semanticColors.background.tertiary,
    border: "none",
    borderRight: `1px solid ${semanticColors.border.secondary}`,
    cursor: "pointer",
  },
  collapsedIcon: {
    color: semanticColors.foreground.secondary,
    flexShrink: 0,
  },
  collapsedTitle: {
    writingMode: "vertical-rl",
    textOrientation: "mixed",
    textTransform: "uppercase",
    fontSize: "11px",
    fontWeight: foundations.typography.fontWeight.medium,
    letterSpacing: "0.08em",
    color: semanticColors.foreground.secondary,
    userSelect: "none",
  },
  info: {
    padding: "16px",
    paddingLeft: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    "& > p": {
      padding: 0,
    },
  },
  sidebarHeader: {
    fontWeight: foundations.typography.fontWeight.medium,
  },
  metaGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  metaRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    color: semanticColors.foreground.secondary,
  },
  metaLabel: {
    fontWeight: foundations.typography.fontWeight.medium,
    marginRight: "4px",
    color: semanticColors.foreground.secondary,
  },
  metaValue: {
    color: semanticColors.foreground.secondary,
  },
  statusGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  badgeRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: semanticColors.foreground.secondary,
  },
  buttons: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  chipMargin: {
    marginLeft: "8px",
  },
  publishedInfoGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  urlGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  urlField: {},
  urlButtons: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  sidebarContainer: {},
  storyContentsWrapper: {
    width: "100%",
    padding: "16px",
    backgroundColor: semanticColors.background.tertiary,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  srOnly: {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0,0,0,0)",
    whiteSpace: "nowrap",
    border: 0,
  },
  tabs: {
    borderBottom: `1px solid ${semanticColors.border.secondary}`,
    minHeight: "36px",
  },
  tabPanel: {
    marginTop: "16px",
  },
  tab: {
    minHeight: "36px",
    padding: "6px 0",
    marginRight: "24px",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: foundations.typography.fontWeight.normal,
    color: semanticColors.foreground.secondary,
    "&.Mui-selected": {
      color: semanticColors.foreground.action,
      fontWeight: foundations.typography.fontWeight.medium,
    },
  },
});
